import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiChevronLeft } from "react-icons/fi";
import UserRegister from "../components/Registration/UserRegister.component";
import ContractorRegister from "../components/Registration/ContractorRegister.component";

// images
import middleman from "../assets/images/user-middleman.png";
import logo from "../assets/images/logo-circle.png";
import contractorImg from "../assets/images/contractor.png";
import ContractorRegisterPopularServices from "../components/Registration/ContractorRegisPopularService";

export default function Signup() {
  /**
   * 0 = default screen of buttons
   * 1 = user register form
   * 2 = contractor register form
   */
  const [userScreen, setUserScreen] = useState(0);
  const [popularService, setPopularService] = useState("");

  return (
    <main>
      {/* <!-- login START --> */}
      {/* Todo :header : paste  */}
      <div className="bds-loginconatiner">
        <div
          className="bds-popupcontainer"
          style={{ width: "clamp(100%,400px,500px)" }}
        >
          <div className="bds-login_title">
            <Link to="/">
              <img src={logo} alt="images description" className="site-logo" />
            </Link>
            {/* <h5>We love to see you joining our community</h5> */}
          </div>
          <div className="bds-login-content bds-popup-content">
            {/* TODD: User and contractor Screen /done */}
            {userScreen == 0 && (
              <div className="grid-container">
                <button
                  className="btn btn-lg purple-gradient-bg user-register-btn"
                  type="button"
                  onClick={() => setUserScreen(1)}
                >
                  <img src={middleman} alt="middleman" className="img-fluid" />
                  <div className="">
                    <small>Register as a</small>
                    <h5>User</h5>
                  </div>
                </button>
                <button
                  className="btn btn-lg user-register-btn sky-blue-bg"
                  type="button"
                  onClick={() => setUserScreen(2)}
                >
                  <img
                    src={contractorImg}
                    alt="middleman"
                    className="img-fluid"
                    width={100}
                    height={100}
                  />
                  <div className="">
                    <small>Register as a</small>
                    <h5>CONTRACTOR</h5>
                  </div>
                </button>
              </div>
            )}
            {/* User Signup */}
            {userScreen == 1 && (
              <>
                <button
                  className="btn btn-link text-decoration-none text-sky-blue d-flex align-items-center p-0 mb-3"
                  onClick={() => setUserScreen(0)}
                >
                  <FiChevronLeft />
                  <span className="ms-1">Back</span>
                </button>
                <UserRegister setUserScreen={setUserScreen}/>
              </>
            )}
            {/* Contractor signup  1st screen
            {userScreen == 2 && (
              <>
                <button
                  className="btn btn-link text-decoration-none text-sky-blue d-flex align-items-center p-0 mb-3"
                  onClick={() => setUserScreen(0)}
                >
                  <FiChevronLeft />
                  <span className="ms-1">Back</span>
                </button>
                <ContractorRegisterPopularServices
                  setUserScreen={setUserScreen}
                  setPopularService={setPopularService}
                  services={services}
                />
              </>
            )} */}
            {/* Contractor signup */}
            {userScreen == 2 && (
              <>
                <button
                  className="btn btn-link text-decoration-none text-sky-blue d-flex align-items-center p-0 mb-3"
                  onClick={() => setUserScreen(0)}
                >
                  <FiChevronLeft />
                  <span className="ms-1">Back</span>
                </button>
                <ContractorRegister />
              </>
            )}
          </div>
        </div>
      </div>
      {/* <!-- login START --> */}
    </main>
  );
}

// some Hard Coded Data Array
const services = [
  "House Cleaning",
  "Graphic Design",
  "Life Coaching ",
  "Book keeping Services ",
  "Web Design ",
  "General builders",
  "General Photogaphy",
  "Personal Trainers",
  "Web Development",
  "Gardening",
  "Social Media Marketing",
  "commercial And Office Cleaning",
];
